import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

const GET_ONBOARDING_CANDIDATE_EVENTS = gql`
    query OnboardingCandidateEvents($candidateUuid: ID) {
        onboardingCandidateEvents(candidateUuid: $candidateUuid) {
            eventCode
            eventMessage
            additionalInfo
            timestamp
        }
    }
`;

const useOnboardingCandidateEvents = (candidateUuid) => {
    const { loading, error, data, refetch } = useQuery(GET_ONBOARDING_CANDIDATE_EVENTS, {
        variables: {
            candidateUuid,
        },
        skip: !candidateUuid,
        fetchPolicy: 'network-only',
    });

    return {
        data: data?.onboardingCandidateEvents,
        loading,
        error,
        refetch,
    };
};

export default useOnboardingCandidateEvents;
